"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CertificateView = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var CertificateView_module_css_1 = tslib_1.__importDefault(require("./CertificateView.module.css"));

var Certificate_1 = tslib_1.__importDefault(require("@skbkontur/react-icons/Certificate"));

var utils_1 = require("../Certificate/utils");

var dayjs_1 = tslib_1.__importDefault(require("dayjs"));

require("dayjs/locale/ru");
/**
 * Простое отображение сертификата.
 */


exports.CertificateView = function (_a) {
  var certificate = _a.certificate;
  var date = dayjs_1.default(certificate.validTo()).locale('ru').format('D MMMM YYYY');
  var validToString = "\u0414\u0435\u0439\u0441\u0442\u0432\u0443\u0435\u0442 \u0434\u043E " + date;
  return react_1.default.createElement("div", {
    className: CertificateView_module_css_1.default.certificate
  }, react_1.default.createElement("div", {
    className: CertificateView_module_css_1.default.qualifiedIcon
  }, react_1.default.createElement(Certificate_1.default, null)), react_1.default.createElement("span", {
    className: CertificateView_module_css_1.default.organizationName
  }, certificate.organizationName()), react_1.default.createElement("div", {
    className: CertificateView_module_css_1.default.innKpp
  }, utils_1.innKppString(certificate.inn(), certificate.kpp(), false)), react_1.default.createElement("div", {
    className: CertificateView_module_css_1.default.owner
  }, certificate.owner()), react_1.default.createElement("div", {
    className: CertificateView_module_css_1.default.validToInfo
  }, validToString));
};